import React, { useState } from 'react';
import SaveButton from '../../../components/Buttons/SaveButton';
import DateControl from '../../../components/Fields/DateControl';
import Field from '../../../components/Fields/Field';
import FieldLabel from '../../../components/Fields/FieldLabel';
import MultiSelectField from '../../../components/Fields/MultiSelectField';
import SelectListField from '../../../components/Fields/SelectListField';
import SwitchField from '../../../components/Fields/SwitchField';
import TextboxField from '../../../components/Fields/TextboxField';
import { FormConfig } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import Popup from '../../../components/Popups/Popup';
import { useNotifications } from '../../../contexts/notificationContext';
import WorkflowDefinitionModel from '../../../models/WorkflowDefinitionModel';
import DataService from '../../../services/data.service';
import { PopupProps } from '../../../types/PopupProps';
import { DataResult } from '../../../types/Result';
import FormatUtils from '../../../utils/FormatUtils';


const CreateWorkflowDefinitionPopup: React.FC<PopupProps> = ({show, onHide}) => {
    const projectTypes = useSelectListOptions('api/v1/selectlist/ProjectTypes', '-- Select project type');
    const itemTypes = useSelectListOptions('api/v1/selectlist/ItemTypes', '-- Select item type');
    const [serverErrors, setServerErrors] = useState<DataResult<WorkflowDefinitionModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<WorkflowDefinitionModel>({
        id: 0,
        name: '',
        itemTypeIds: [],
        projectTypeIds: [],
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
        endDate: '',
        allowMultipleActiveInstances: false,
        concurrencyId: ''
    });

    const executionTypes = useSelectListOptions('api/v1/selectlist/WorkflowExecutionTypes', '-- Ask');

    function submit() {
        if (formData) {
            DataService
                .create<WorkflowDefinitionModel>(`api/v1/WorkflowDefinitions/`, formData)
                .then(response => {
                    handleResult(response)
                    setServerErrors(response)
                    if (response.isSuccesful === true && response.data)
                        onHide()
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'description', label: 'Description' },
            { name: 'workflowExecutionTypeId', label: 'Execution type' },
            { name: 'projectTypeIds', label: 'Project types' },
            { name: 'itemTypeIds', label: 'Item types' },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
            { name: 'allowMultipleActiveInstances', label: 'Allow multiple active instaces' },

        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Create workflow'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('name')} />
                <TextboxField {...getFieldProps('description')} />
                <SelectListField {...getFieldProps('workflowExecutionTypeId')} options={executionTypes} />
                <MultiSelectField {...getFieldProps('projectTypeIds')} options={projectTypes} />
                <MultiSelectField {...getFieldProps('itemTypeIds')} options={itemTypes} />
                <Field {...getLabelProps('beginDate')}>
                    <DateControl {...getControlProps('beginDate')} />
                    <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                    <DateControl {...getControlProps('endDate')} />
                </Field>
                <SwitchField {...getFieldProps('allowMultipleActiveInstances')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Create' />
            </Popup.Footer>
        </Popup>
    );
}
export default CreateWorkflowDefinitionPopup;